module.exports = __webpack_public_path__ + "img/ic_satisfied_grey.9efe4e17.svg";